<template lang="html">
  <transition name="modal-fade">
    <div class="modal-background">

  		<div id="user-position-select" class="white-box" role="dialog">
  			<span id="user-position-select-close-btn" role="button" aria-label="Gå tilbage" @click="$emit('close');" tabindex="0">
          <span class="material-icons grey-text">close</span>
        </span>
  			<div class="user-position-option">
  				<div class="user-position-img-btn" role="button" aria-label="Vis afstand fra en adresse, du indtaster." @click="$emit('selectOption', 'address');" tabindex="0">
            <span class="material-icons" aria-hidden="true">place</span>
          </div>
  				<p aria-hidden="true">Vis afstand fra en adresse, du indtaster.</p>
  			</div>
  			<div class="user-position-option">
  				<div class="user-position-img-btn" role="button" aria-label="Vis afstand fra et af dine favoritsteder." @click="checkIfLoggedIn('userFavorite');" tabindex="0">
            <span class="material-icons" aria-hidden="true">favorite_border</span>
          </div>
  				<p aria-hidden="true">Vis afstand fra et af dine favoritsteder.</p>
  			</div>
  			<div class="user-position-option">
  				<div class="user-position-img-btn" role="button" aria-label="Vis afstand fra en af dine adresser." @click="checkIfLoggedIn('userAddress');" tabindex="0">
            <span class="material-icons" aria-hidden="true">person_pin</span>
          </div>
  				<p aria-hidden="true">Vis afstand fra en af dine adresser.</p>
  			</div>
  		</div>

    </div>
  </transition>
</template>

<script>
import Profile from '@/assets/profile/Profile.js'
import { EventBus } from '@/main.js'

export default {
  methods: {
    checkIfLoggedIn(option) {
      if(Profile.loggedIn) {
        this.$emit('selectOption', option);
      }
      else {
        this.$emit('close');
        var options = {message: 'Log først ind eller opret en profil', btnText: 'Gå til login', cancelBtnText: 'Gå tilbage', callbackType: 'link', callback: '/login'};
        EventBus.$emit('openMessageBox', options);
      }
    }
  }
}
</script>

<style lang="css">
#user-position-select {
  position: absolute;
  width: 300px;
	padding: 10px;
}

.user-position-option {
	display: inline-block;
	height: 100%;
  width: 33%;
	margin-top: 10px;
  padding: 0px;
	text-align: center;
  cursor: pointer;
}

.user-position-img-btn {
	position: relative;
  left: 50%;
  margin-left: -25px;
  height: 50px;
  width: 50px;
  border: 2px solid #f1f1f1;
  border-radius: 50px;
}

.user-position-img-btn .material-icons {
	position: relative;
  top: 5px;
  font-size: 40px !important;
  color: #a3a3a3;
}

#user-position-select-close-btn {
  position: absolute;
  height: 30px;
  top: 4px;
  right: 5px;
  cursor: pointer;
}

/*Landscape - LG*/
@media screen and (min-width: 768px) and (orientation: landscape) {
  #user-position-select {
    width: 400px;
  }

	.user-position-img-btn {
    margin-left: -50px;
    height: 100px;
    width: 100px;
	}

	.user-position-img-btn .material-icons {
    font-size: 60px !important;
    top: 20px;
	}
}
</style>
